// ** ytx
const initialState = {
  ytx: false
}

const ytx = (state = initialState, action) => {
  switch (action.type) {
    case "YTX":
      return { ...state, ytx: action.val }
    default:
      return state
  }
}

export default ytx
